import mutations from './mutations'
import actions from './actions'
import getters from'./getters'
export default {
    state: {
        dropdowns: [],
        dropdownsState: '',
        dropdown: {},
        sites: [],
        sitesState: '',
        site: {},
        sections: [],
        sectionsState: '',
        section: {},
    },
    mutations,
    actions,
    getters
}
